/* import __COLOCATED_TEMPLATE__ from './text-action.hbs'; */
import Component from '@ember/component';

/**
This component should be used when you want to bind action(s) to text within a translation.

Example:
HBS
```hbs
<TextAction @goodAction={{action 'someAction1'}} @badAction={{action 'someAction2'}}>
  {{t "key.to.translation" htmlSafe=true}}
</TextAction>
```

Translation Key
"This does <a data-text-action='goodAction'>good</a> and this does <a data-text-action='badAction'>bad</a>."
*/
export default Component.extend({
  tagName: 'span',
  click(event) {
    const translationAction = event.target.dataset.textAction;
    if (translationAction && this.get(translationAction)) {
      this.get(translationAction)();
    }
  }
});